import BottomSheet from "../../../components/BottomSheet/BottomSheet"
import PrimaryButton from "../../../components/PrimaryButton/PrimaryButton"
import useStrings from "../../../localization/useStrings"
import { useFreeTrialPaywall } from "../freeTrialPaywallContext"
import styles from "./ComparePlansSheet.module.scss"
import useComparePlans, { FreeTrialPlan } from "./useComparePlans"

const ComparePlansSheet = () => {
  const { actions, state } = useFreeTrialPaywall()
  const { state: plansState, actions: plansActions } = useComparePlans()
  const strings = useStrings().freeTrialPaywall.comparePlans

  return (
    <BottomSheet visible={state.showPlanSheet} onClose={() => actions.setShowPlanSheet(false)}>
      <div className={styles.topSpacer}></div>
      <PlanBox onClick={() => plansActions.setYearlySelected(true)} plan={plansState.yearly} />
      <PlanBox onClick={() => plansActions.setYearlySelected(false)} plan={plansState.monthly} />
      <PrimaryButton className={styles.cta} onClick={plansActions.purchaseCurrent}>
        {strings.cta}
      </PrimaryButton>
    </BottomSheet>
  )
}

interface PlanBoxProps {
  onClick: () => void
  plan: FreeTrialPlan
}

const PlanBox = (props: PlanBoxProps) => {
  const { plan, onClick } = props
  const selected = plan.selected

  return (
    <button className={`${styles.priceBox} ${selected ? styles.selected : ""}`} onClick={onClick}>
      <div className={styles.left}>
        <label className={styles.leftTitle}>{plan.name}</label>
        <label className={styles.leftSubtitle}>{plan.price}</label>
      </div>
      <div className={styles.right}>
        <label className={styles.rightTitle}>{plan.timePeriodPrice}</label>
        <label className={styles.rightSubtitle}>{plan.timePeriodSubtitle}</label>
      </div>
    </button>
  )
}

export default ComparePlansSheet
